import { CurrencyService } from '../index';
import { ATTR_DATA_PAGE, ATTR_DATA_REBORN, BLACK_LIST } from './constants';

export const isConversionAuthorized = function () {
  const bodyPage = document.getElementsByTagName('body')[0];
  const haveConversionTrue = bodyPage.getAttribute(ATTR_DATA_PAGE);
  const haveRebornConversion = bodyPage.getAttribute(ATTR_DATA_REBORN);
  const idPage = bodyPage.getAttribute('id');
  return (
    haveConversionTrue == 'true' ||
    haveRebornConversion == 'true' ||
    BLACK_LIST.indexOf(idPage) == -1
  );
};

async function getCurrencyViewBean() {
  const currencyService = new CurrencyService();
  const result = await currencyService.getCurrencyContext();
  return {
    currencyViewBean: result?.currenciesViewBean,
    conversionAuthorized: result?.conversionAuthorized
  };
}

async function defaultAPICurrency() {
  const { currencyViewBean } = await getCurrencyViewBean();
  return currencyViewBean?.defaultCurrency;
}

function buildContinent(currencyViewBean) {
  if (!currencyViewBean) {
    throw new TypeError('Missing arg currencyViewBean');
  }
  const continents = [];
  for (const key in currencyViewBean) {
    const continent = {
      text: key.charAt(0).toUpperCase() + key.slice(1),
      value: key,
      attributes: [
        {
          'data-id': key
        }
      ],
      options: []
    };
    continents.push(continent);
  }
  return continents;
}

function buildOptionsByContinent(currencyViewBean, continents) {
  if (!continents || !continents.length) {
    throw new TypeError('Missing arg continents || empty continents arg');
  }
  if (!currencyViewBean?.displayCurrenciesMap) {
    throw new TypeError(
      'Missing arg currencyViewBean || undefined property displayCurrenciesMap in currencyViewBean'
    );
  }

  for (const continent in currencyViewBean.displayCurrenciesMap) {
    const options = [];
    for (const currency of currencyViewBean.displayCurrenciesMap[continent]) {
      const option = {
        text: `${currency} - ${currencyViewBean.currenciesName[currency]}`,
        value: currency,
        attributes: [
          {
            'data-continent': continent,
            'data-currency': currency,
            lang: 'en'
          }
        ]
      };
      options.push(option);
    }
    const ctns = continents.find((ctn) => ctn.value === continent);
    ctns.options = options;
  }
  return continents;
}

export {
  buildOptionsByContinent,
  buildContinent,
  defaultAPICurrency,
  getCurrencyViewBean
};
